module.exports = __webpack_public_path__ + "static/media/countdownNew.bdfca259.mp3";